export enum WorkflowTypesList {
    ENTITIES = 'entities',
    ACTIONS = 'actions',
    STOP_TRIGGERS = 'stop-triggers'
}
